/**
 * This file defines min/max limits for a person's birthdate based on their
 * relationship to the applicant.
 */
import { DateTime } from 'luxon';

// eApp only does comparisons of "Date" and does not have any form entries for
// time. Without setting the times to 0, any form entries using today's date
// will not pass the comparison, as TODAY would always have a greater value due
// to the times.
export const TODAY = DateTime.local().set({
  second: 0, hour: 0, minute: 0, millisecond: 0
});
export const THIS_MONTH = DateTime.local().set({
  day: 1, second: 0, hour: 0, minute: 0, millisecond: 0
});
export const DEFAULT_LATEST = TODAY;
export const DEFAULT_FUTURE_LATEST = TODAY.plus({ years: 200 });
export const DEFAULT_EARLIEST = TODAY.minus({ years: 200 });
export const LAST_SEVEN_YEARS = TODAY.minus({ years: 7 });
export const LAST_FIVE_YEARS = TODAY.minus({ years: 5 });
export const LAST_THREE_YEARS = TODAY.minus({ years: 3 });
/**
 * Applicant birthdate must be:
 * - less than 100 years ago
 * - more than 16 years ago
 */
export const SELF = {
  earliest: (TODAY.minus({ years: 100 })).plus({ days: 1 }),
  latest: TODAY.minus({ years: 16 }),
};

/**
 * Other person's birthdate must be:
 * - no more than 200 years ago
 * - not in the future
 */
export const OTHER = {
  earliest: DEFAULT_EARLIEST,
  latest: DEFAULT_LATEST,
};
